import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';

@Component({
  selector: 'app-collapsible-section',
  templateUrl: 'collapsible-section.component.html',
  styleUrls: ['collapsible-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleSectionComponent implements OnInit {
  @Input() header: string;
  @Input() icon: IIcon;
  @Input() isOpen: boolean;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;

  @Output() onOpenToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {
    if (!this.icon) {
      this.icon = {
        name: 'chevron-down',
        size: IconSizesEnum.small,
      };
    }
  }

  toggleVisibility() {
    this.isOpen = !this.isOpen;

    this.onOpenToggle.emit(this.isOpen);
  }
}
